import React, {createContext, useEffect, useState} from 'react';
import useStorage from "../Storage/useStorage";
import {webInfo} from "../utils/webInfo";

export const MyContext = createContext<any>({});
const DataContext = ({ children }:any) => {
    const [accessToken, setAccessToken] = useState<any>(null)
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        const refresh = async () => {
            try {
                const res = await fetch(`${webInfo.baseUrl}/api/admin/refresh`, {
                    method: 'GET',
                    credentials: 'include',
                });
                const resData = await res.json();
                if (res.ok) {
                    setAccessToken(resData.chemist_admin_token);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }finally {
                setLoader(false);
            }
        };
        if (!accessToken) {
            refresh().then();
        }

        const interval = setInterval(refresh, 14 * 60 * 1000);
        return () => clearInterval(interval);
    }, [setLoader, accessToken]);


    const url = `${webInfo.baseUrl}/api/admin/me`;
    const [user, setUser] = useState(null)

    useEffect(() => {
        if (!accessToken) return
        const getUser = async () => {
            try {
                const res = await fetch(url, {
                    method: 'GET',
                    headers:{
                        authorization: `Bearer ${accessToken}`,
                    }
                });
                if (res.ok) {
                    const resData = await res.json();
                    setUser(resData.data);
                }
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        getUser();
        // eslint-disable-next-line
    }, [accessToken])

    const data = useStorage();
    const value = {
        ...data,
        accessToken,
        setAccessToken,
        loader,
        user
    }

    return <MyContext.Provider value={value}>{children}</MyContext.Provider>;
};

export default DataContext;
